/* global COGNITO_AWS_PROJECT_REGION, COGNITO_REGION, COGNITO_USER_POOL_ID, COGNITO_USER_POOL_WEB_CLIENTID, COGNITO_MANDATORY_SIGNIN, COGNITO_AUTHENTICATION_FLOW_TYPE */
const awscongig = {
  aws_project_region: COGNITO_AWS_PROJECT_REGION,
  Auth: {
    // Amazon Cognito Region
    region: COGNITO_REGION,

    // Amazon Cognito User Pool ID
    userPoolId: COGNITO_USER_POOL_ID,

    // Amazon Cognito Web Client ID (26-char alphanumeric string)
    userPoolWebClientId: COGNITO_USER_POOL_WEB_CLIENTID,

    // Enforce user authentication prior to accessing AWS resources or not
    mandatorySignIn: COGNITO_MANDATORY_SIGNIN,

    // Manually set the authentication flow type. Default is 'USER_SRP_AUTH'
    authenticationFlowType: COGNITO_AUTHENTICATION_FLOW_TYPE
  }
};

export default awscongig;
